import { isTag } from "domhandler";
import { decode } from "html-entities";
import React, { useRef } from "react";
import shortid from "shortid";
import styled from "styled-components";

import Tooltip from "../../tooltip/Tooltip";
import { sanitizeRichContent } from "../utils";

import { HtmlToReactProcessor } from "./processor";

const ProcessAdditionalContext =
  (
    enabled: boolean | undefined,
    sanitize: boolean | undefined,
  ): HtmlToReactProcessor =>
  (node, _children, _index, defaultProcessor) => {
    if (
      !isTag(node) ||
      node.name !== "span" ||
      !node.attribs["data-additional-context"] ||
      !enabled
    ) {
      return;
    }

    const defaultResult = defaultProcessor();
    if (defaultResult === false) {
      // This only happens for comment nodes, so we'll actually never get here
      return undefined;
    }

    const contextContent = sanitizeRichContent(
      decode(node.attribs["data-additional-context"]),
      sanitize,
    );

    return (
      <AdditionalContextTooltip
        {...defaultResult.props}
        content={contextContent}
      />
    );
  };

const StyledAdditionalContext = styled.a`
  border-bottom: 1px dotted grey;
  color: inherit;
  text-decoration: inherit;
`;

const AdditionalContextTooltip: React.FC<
  React.PropsWithChildren<{ content: string }>
> = ({ content, ...props }) => {
  const { current: definitionId } = useRef(shortid());

  return (
    <>
      <Tooltip
        tip={
          <dfn
            id={definitionId}
            dangerouslySetInnerHTML={{ __html: content }}
            role="alert"
          />
        }
        placement="top"
        showOn="click"
      >
        <StyledAdditionalContext {...props} href={`#${definitionId}`} />
      </Tooltip>
    </>
  );
};

export default ProcessAdditionalContext;
